/*
 * This renders UI for Noun Project staff and Admin to get to fort quicker
 * For use in hero
 *
 */
let React = require("react");

export class SuperUserActions extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showSuperUserActions: true
        };
    }

    toggleSuperUserActions(e) {
        e.preventDefault();
        this.setState({
            showSuperUserActions: false
        });
    }

    render() {
        if (!this.props.superUser || !this.state.showSuperUserActions) {
            // Super User Actions are for super users who haven't hidden the menureturn Null
            return false;
        }

        return (
            <div className="super-user-actions">
                <ul>
                    <li>
                        <a
                            className="super-user-action-link ui_pencil"
                            target="_blank"
                            title="Open icon in fort"
                            href={`/fort/icon/${this.props.iconId}/`}
                        />
                    </li>
                    <li>
                        <a
                            className="super-user-action-link ui_user"
                            target="_blank"
                            title="Open icon's creator in fort"
                            href={`/fort/members/${this.props.uploaderId}/`}
                        />
                    </li>
                </ul>
                <a
                    href="#"
                    onClick={this.toggleSuperUserActions.bind(this)}
                    title="Temporarily hide this menu"
                    style={{
                        position: "absolute",
                        bottom: "-24px"
                    }}
                >
                    &times;
                </a>
            </div>
        );
    }
}
